import apiClient from '@u/apiClient'
import router from '@/router'

let base_errors = {}

export default {
  //region fetch
  async fetchCheckDepositList({ commit }) {
    await apiClient
      .get('api/fetch-check-deposit')
      .then(async (response) => {
        await commit('setCheckDepositList', response.data.check_deposits)
        await commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchChecksList', reason)
      })
  },
  async fetchCheckDepositById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/check-deposit/${payload.check_deposit}`)
      .then(async (response) => {
        await commit('setCheckDeposit', response.data.check_deposit)
        await commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchCheckDepositById', reason)
      })
  },
  async fetchCheckByStatus({ commit }, payload) {
    await apiClient
      .get(`api/fetch-checks-by-status/${payload.status}`)
      .then(async (response) => {
        commit('setCheckListByType', response.data.checks)
        commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchCheckByStatus', reason)
      })
  },
  async fetchNewCheckDeposit({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get('api/model/new?model=CheckDeposit')
      .then(async (response) => {
        await commit('setCheckDeposit', response.data.CheckDeposit)
        await commit('setCheckMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchNewCheckDeposit', reason)
      })
  },
  //endregion

  //region store
  storeCheckDeposit(_, payload) {
    return apiClient
      .post('api/check-deposit', payload.checkDeposit)
      .then(async (response) => {
        await router.push({ name: 'check_index_route' })
        return response.data
      })
  },
  //endregion

  //region update
  updateCheckDeposit(_, payload) {
    return apiClient
      .put(`api/check-deposit/${payload.id}`, payload.checkDeposit)
      .then(async (response) => {
        await router.push({ name: 'check_index_route' })
        return response.data
      })
  }
  //endregion
}
